// extracted by mini-css-extract-plugin
module.exports = {"Modals":"Modals_Modals__1gab2"};